import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavListCommonProps } from 'src/app/components/nav/nav.component';
import { environment } from 'src/environments/environment';
import { GroupBy } from '../_enums/groupby';
import { SiteMapUrl } from '../_enums/sitemap.url';
import { Acheminement } from '../_models/acheminement';
import { Journeys } from '../_models/journeys';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AcheminementService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  getAcheminement(acheminementId: string) {
    return this.http.get<Acheminement>(`${environment.apiUrl}/Acheminements/${acheminementId}`, { headers: this.authService.headers });
  }

  getAll(groupBy?: string) {
    let params = new HttpParams();
    params = groupBy ? params.set('groupBy', groupBy) : params;

    return this.http.get<any>(`${environment.apiUrl}/Acheminements`, { params: params, headers: this.authService.headers });
  }

  getFlat() {
    return this.http.get<Acheminement[]>(`${environment.apiUrl}/Acheminements/flatList`, { headers: this.authService.headers });
  }

  update(acheminement: Acheminement) {
    return this.http.put<Acheminement>(`${environment.apiUrl}/Acheminements/${acheminement.resourceId}`, acheminement, { headers: this.authService.headers });
  }

  add(acheminement: Acheminement) {
    return this.http.post<Acheminement>(`${environment.apiUrl}/Acheminements`, acheminement, { headers: this.authService.headers });
  }

  delete(resourceId: string) {
    return this.http.delete(`${environment.apiUrl}/Acheminements/${resourceId}`, { headers: this.authService.headers });
  }

  duplicate(resourceId: string, code: string) {
    return this.http.post(`${environment.apiUrl}/Acheminements/duplicate?id=${resourceId}&code=${encodeURIComponent(code)}`, null, { headers: this.authService.headers });
  }

  getJourneysForAcheminement(acheminementId: string) {
    return this.http.get<Journeys[]>(`${environment.apiUrl}/Acheminements/GetJourneysForAcheminement/${acheminementId}`, { headers: this.authService.headers });
  }

  getNavConfig({ perimeterId }: NavListCommonProps) {
    return {
      header: {
        title: 'ressource_list_title_transportations',
        actions: [{ label: 'ressource_list_action_add', onClick: () => this.router.navigate([`${SiteMapUrl.MenuAcheminement}/new`, 0], { state: { perimeterId } }) }],
        filters: [
          { label: 'ressource_list_filter_by_family', value: GroupBy.family },
          { label: 'ressource_list_filter_by_favorite', value: GroupBy.favorite }
        ],
        defaultFilter: GroupBy.family
      },
      getItemConfig: (node: any) => {
        return {
          displayName: `${node.displayName} [${node.code}]`,
          url: `${SiteMapUrl.MenuAcheminement}/${node.resourceId}`,
          itemType: 'acheminement',
          state: {
            resourceId: node.resourceId,
            perimeterId
          }
        };
      },
      getDataSource: this.getAll.bind(this),
      getEditableFamilyId: () => 'DA169E41-4BC9-DE11-BB04-0019DB88F410'
    };
  }
}
